export const getTravelReplacementConsistencyOverride = (activity) => {
  if (activity?.source?.compliance_role === 'travel_replacement') {
    return { handled: true, value: null };
  }
  if (activity?.type === 'workout' && activity?.status === 'replaced') {
    const planned = activity?.source?.activity_snapshot?.data?.exercises;
    const actual = activity?.data?.exercises;
    const plannedCount = (Array.isArray(planned) && planned.length > 0 ? planned.length : actual?.length) || 1;
    return {
      handled: true,
      value: { earned: plannedCount, pr: 0, pending: 0, missed: 0 },
    };
  }
  return { handled: false, value: null };
};
